var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2199_26698)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.4367 22.294C27.9066 21.19 30.9799 16.9215 30.4651 12.2189C29.9041 7.09487 25.2955 3.39578 20.1714 3.95676C15.4688 4.4716 11.9664 8.39563 11.8557 12.9985M11.827 19.6246L13.67 18.0815L14.4681 25.3713M12.48 25.589L16.4562 25.1536M23.3832 21.042C23.9442 26.1661 20.2451 30.7747 15.1211 31.3357C9.99701 31.8966 5.38839 28.1976 4.82741 23.0735C4.26644 17.9495 7.96553 13.3409 13.0896 12.7799C18.2136 12.2189 22.8222 15.918 23.3832 21.042Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2199_26698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 3.48254) rotate(-6.24783)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.d16aa89b67c3ded066f6a4dfe0bc152a.svg";
export { ForwardRef as ReactComponent };